// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"0d457eae","787":"59cfb37a"}[chunkId] + ".chunk.js";
};